import withParams from "@src/components/widgets/HOC/withParams";
import React from "react";
import { WidgetTemplateComponentType } from "@src/interface/Widget";
import { ILandingStandardWidgetVideoParams } from "../interface";
import MargauxMotinVideo from "design-system/src/Components/WidgetPart/LandingVideo/MargauxMotinVideo/MargauxMotinVideo";
import StyledDiv from "design-system/src/Components/StyledDiv/StyledDiv";

const VideoMargauxMotin: WidgetTemplateComponentType =
  withParams<ILandingStandardWidgetVideoParams>((props) => {
    const { p } = props;

    return (
      <StyledDiv
        styles={{
          padding: "24px",
          overflowX: "hidden",
        }}
      >
        <MargauxMotinVideo
          videoId={p("video_src") || ""}
          poster={{
            desktop: p("poster_desktop") + "",
            mobile: p("poster_mobile") + "",
          }}
          aspectRatio={16/9}
        />
      </StyledDiv>
    );
  });

export default VideoMargauxMotin;
